import axios from 'axios'
import config from '@/config'

export default {
  state: {
    isPipelineRunning: false
  },

  mutations: {
    SET_PIPELINE_NOT_READY (state, value) {
      state.isPipelineRunning = value
    }
  },

  actions: {
    checkPipelineStatus (context, { token, pipelineId }) {
      return axios.post(config.pipelineUrl, {
        token,
        pipeline_id: pipelineId
      })
    },
    setIsPipelineRunning ({ commit }, value) {
      commit('SET_PIPELINE_NOT_READY', value)
    }
  }
}
